(function() {
    'use strict';

    angular
        .module('app.empleados')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/empleados',
                config: {
                    templateUrl: 'app/empleados/empleados.html',
                    controller: 'Empleados',
                    controllerAs: 'vm',
                    title: 'Empleados'
                }
            },
            {
                url: '/editar-empleado/:id?',
                config: {
                    templateUrl: 'app/empleados/editarEmpleado.html',
                    controller: 'EditarEmpleado',
                    controllerAs: 'vm',
                    title: 'EditarEmpleado'
                }
            },
            {
                url: '/salario-promedio-mensual/:id/:nombre',
                config: {
                    templateUrl: 'app/empleados/salarioPromedioMensual.html',
                    controller: 'SalarioPromedioMensual',
                    controllerAs: 'vm',
                    title: 'SalarioPromedioMensual'
                }
            }
        ];
    }
})();
